import { ChangesetDetails } from 'domain/index';
import { GetChangeOnField } from 'features/edit/shared';
import _ from 'lodash';

const DETAIL_FIELDS = ['description', 'details'] as string[];

export const GetHasChangesInDetails = (turbineId: number, changesetDetails?: ChangesetDetails): boolean => {
  return _.some(DETAIL_FIELDS, (fieldName) => GetChangeOnField(turbineId, fieldName, changesetDetails));
};
